import type { AvatarProps } from '@workramp/ui';
import { useTheme } from 'styled-components';
import { P, Avatar, Span } from '@workramp/ui';
import { getColorsForAvatar, getLettersForAvatar } from '~/utils/avatar';
import { MediaObject } from '../MediaObject';
import { AvatarButton, MediaObjectWrapper, NameLink } from './UserMediaObject.styles';

export interface UserMediaObjectProps extends Pick<AvatarProps, 'size' | 'iconName' | 'imgUrl'> {
  name: string;
  email?: string;
  brandColor?: string;
  href?: string;
  removeLinkColor?: boolean;
  onPress?: () => void;
}

export function UserMediaObject({
  name,
  email,
  brandColor,
  href,
  onPress,
  size = 'lg',
  removeLinkColor = false,
  ...avatarProps
}: UserMediaObjectProps) {
  const theme = useTheme();
  // Generate initials
  const letters = getLettersForAvatar(name);

  // Generate custom colors
  const colors = getColorsForAvatar(theme, brandColor);

  const avatar = <Avatar letters={letters} size={size} {...colors} {...avatarProps} />;

  const isInteractive = onPress || href;

  return (
    <MediaObjectWrapper>
      <MediaObject
        media={
          isInteractive ? (
            <AvatarButton href={href} onPress={onPress}>
              {avatar}
            </AvatarButton>
          ) : (
            avatar
          )
        }
        title={
          isInteractive ? (
            <NameLink $matchColor={removeLinkColor} href={href} onPress={onPress}>
              <Span size={1} weight="medium" maxLines={1}>
                {name}
              </Span>
            </NameLink>
          ) : (
            <P size={1} weight="medium" maxLines={1} isExpandable>
              {name}
            </P>
          )
        }
        description={
          email && (
            <Span size={0} maxLines={1} isExpandable>
              {email}
            </Span>
          )
        }
      />
    </MediaObjectWrapper>
  );
}
